module.exports = __webpack_public_path__ + "static/4-b87e6febeb693836279b516a93289bf2.jpg";